// Beautiful gradient color combinations
const gradients = [
  'from-blue-500 to-purple-600',
  'from-purple-500 to-pink-600',
  'from-pink-500 to-red-600',
  'from-red-500 to-orange-600',
  'from-orange-500 to-yellow-600',
  'from-yellow-500 to-green-600',
  'from-green-500 to-teal-600',
  'from-teal-500 to-cyan-600',
  'from-cyan-500 to-blue-600',
  'from-indigo-500 to-purple-600',
  'from-violet-500 to-purple-600',
  'from-fuchsia-500 to-pink-600',
  'from-rose-500 to-pink-600',
  'from-emerald-500 to-teal-600',
  'from-sky-500 to-blue-600',
  'from-lime-500 to-green-600',
  'from-amber-500 to-orange-600',
]

export function getRandomGradient(): string {
  return gradients[Math.floor(Math.random() * gradients.length)]
}

export function getGradientByIndex(index: number): string {
  return gradients[index % gradients.length]
}

export function getConsistentGradient(id: string): string {
  let hash = 0
  for (let i = 0; i < id.length; i++) {
    hash = ((hash << 5) - hash) + id.charCodeAt(i)
    hash = hash & hash // Convert to 32bit integer
  }
  return gradients[Math.abs(hash) % gradients.length]
}
